/* Native modal dialog: media is requested only after a tutorial is selected. */
(function () {
  const instances = new WeakMap();
  function youtubeId(href) {
    const url = new URL(href);
    let id;
    if (url.hostname === 'youtu.be') id = url.pathname.slice(1);
    if (['youtube.com', 'www.youtube.com', 'm.youtube.com'].includes(url.hostname)) id = url.searchParams.get('v');
    return /^[\w-]{11}$/.test(id || '') ? id : null;
  }
  function initTutorials(scope) {
    const sections = [...scope.querySelectorAll('[data-pg-tutorials]')];
    if (scope.matches?.('[data-pg-tutorials]')) sections.unshift(scope);
    const cleanups = sections.map(section => {
      if (instances.has(section)) return instances.get(section);
      const dialog = section.querySelector('[data-pg-tutorial-dialog]');
      if (!dialog || typeof dialog.showModal !== 'function') return () => {};
      const video = dialog.querySelector('video');
      const title = dialog.querySelector('[data-pg-tutorial-title]');
      const error = dialog.querySelector('[data-pg-tutorial-error]');
      const fallback = dialog.querySelector('[data-pg-tutorial-fallback]');
      let opener;
      function release() {
        dialog.querySelector('iframe')?.remove();
        video.pause(); video.removeAttribute('src'); video.removeAttribute('poster'); video.load();
        error.hidden = true;
        if (opener?.isConnected) opener.focus({preventScroll:true});
        opener = null;
      }
      function click(event) {
        const trigger = event.target.closest('[data-pg-tutorial]');
        if (trigger && !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey && event.button === 0) {
          event.preventDefault();
          if (dialog.open) dialog.close();
          opener = trigger;
          title.textContent = trigger.dataset.title;
          video.setAttribute('aria-label', trigger.dataset.title);
          const youtube = youtubeId(trigger.href);
          video.hidden = Boolean(youtube);
          if (youtube) {
            const frame = section.ownerDocument.createElement('iframe');
            frame.title = trigger.dataset.title;
            frame.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
            frame.setAttribute('allowfullscreen', '');
            frame.referrerPolicy = 'strict-origin-when-cross-origin';
            frame.src = 'https://www.youtube-nocookie.com/embed/' + youtube + '?autoplay=1&rel=0';
            video.after(frame);
          } else {
            video.src = trigger.href;
            if (trigger.dataset.poster) video.poster = trigger.dataset.poster;
          }
          fallback.href = trigger.href;
          error.hidden = true;
          dialog.showModal();
          dialog.querySelector('[data-pg-tutorial-close]').focus();
          // Browsers that block playback still expose the native play control.
          if (!youtube) video.play()?.catch(() => {});
        }
        if (event.target.closest('[data-pg-tutorial-close]')) dialog.close();
        if (event.target === dialog) {
          const rect = dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
        }
      }
      const failed = () => { error.hidden = false; };
      section.addEventListener('click', click);
      dialog.addEventListener('close', release);
      video.addEventListener('error', failed);
      function destroy() {
        if (dialog.open) dialog.close(); else if (video.hasAttribute('src')) release();
        section.removeEventListener('click', click);
        dialog.removeEventListener('close', release);
        video.removeEventListener('error', failed);
        instances.delete(section);
      }
      instances.set(section, destroy);
      return destroy;
    });
    return () => cleanups.forEach(cleanup => cleanup());
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = {initTutorials};
  if (typeof document === 'undefined') return;
  initTutorials(document);
  document.addEventListener('shopify:section:load', event => initTutorials(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-pg-tutorials]').forEach(section => instances.get(section)?.());
  });
})();
